{
  "addons.addonList": "Csatlakoztatott egységek",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Hozzon létre és kérjen le API-kulcsot erről a linkről",
  "addons.ambientWeatherDescription": "Környezeti időjárási állomások (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API kulcs",
  "addons.applicationKey": "Alkalmazáskulcs",
  "addons.connect": "Kapcsolódás",
  "addons.davisApiSecret": "Titkos API",
  "addons.davisApiV2Key": "API-kulcs V2",
  "addons.davisDescription": "Davis meteorológiai állomások (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Töltse le a V2 API-kulcsokat erről a linkről",
  "addons.disconnect": "Lecsatlakozás",
  "addons.ecowittCreateAndRetrieveKeys": "Hozzon létre és kérjen le API-kulcsot és alkalmazáskulcsot erről a linkről",
  "addons.ecowittDescription": "Az Ecowitt professzionális meteorológiai állomásokat, vezeték nélküli beltéri/kültéri hőmérőket, nagy pontosságú esőmérőket, levegőminőség-érzékelőket és még sok mást kínál.",
  "addons.helpLink": "",
  "addons.myAcuriteAccountOnHold": "Fiókját felfüggesztettük. Kérjük, adja meg jelszavát a fiók újracsatlakozásához",
  "addons.myAcuriteDescription": "Az AcuRite az első számú meteorológiai állomás márka Észak-Amerikában. Az idő-, hőmérséklet- és időjárástechnológiában vezető szerepet betöltő AcuRite részletes információkat nyújt bel- és kültéri környezetéről, így magabiztosan tervezheti a napját.",
  "addons.myAcuriteEnterCredentials": "Adja meg My AcuRite hitelesítő adatait, hogy összekapcsolja My AcuRite fiókját a SmartMixinnel",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "A Netatmo Thermostat segítségével akár a világ másik feléről is szabályozhatod otthonod fűtését.",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Az okos időjárás állomás",
  "addons.or": "vagy",
  "addons.providerAccountDisconnected": "Az időjárás-szolgáltatáshoz való kapcsolat lejárt. Kérjük, csatlakozzon újra az adatfrissítések folytatásához.",
  "addons.reconnect": "Újrakapcsolódás",
  "addons.weatherflowCreateToken": "Hozd létre és kérd le a tokent erről a linkről",
  "addons.weatherflowTempestDescription": "A Weatherflow által kifejlesztett vihar meteorológiai állomás",
  "addons.wundergroundApiKey": "API kulcs",
  "addons.wundergroundDescription": "A Weather Underground egy olyan emberek globális közössége, akik környezeti érzékelőktől, például időjárás-állomásoktól és levegőminőség-figyelőktől származó adatokat kapcsolnak össze, hogy gazdag, hiperlokális adatokat szállíthassunk, amelyekre szüksége van szenvedélyeinek táplálásához.",
  "addons.wundergroundRetrieveApiKey": "Töltse le az API-kulcsot erről a linkről",
  "addons.wundergroundRetrieveStationId": "Az állomásazonosító (ID) lekérése erről a linkről",
  "addons.wundergroundStationId": "Állomásazonosító",
  "airQuality.airQuality": "Levegő minősége",
  "airQuality.airQualityIndex": "Levegőminőségi index",
  "airQuality.co": "Szén-monoxid",
  "airQuality.good": "Jó",
  "airQuality.goodDescription": "A levegő minősége kielégítőnek tekinthető, és a légszennyezés csekély vagy egyáltalán nem jelent kockázatot.",
  "airQuality.hazardous": "Veszélyes",
  "airQuality.hazardousDescription": "Egészségügyi figyelmeztetés: Bárki tapasztalhat komolyabb egészségügyi hatásokat.",
  "airQuality.indoorAirQuality": "Beltéri levegő minősége",
  "airQuality.moderate": "Mérsékelt",
  "airQuality.moderateDescription": "A levegő minősége elfogadható. Egyes szennyező anyagok azonban egészségügyi kockázatot jelenthetnek nagyon kis számú, a levegőszennyezésre szokatlanul érzékeny ember számára.",
  "airQuality.no2": "Nitrogén-dioxid",
  "airQuality.o3": "Ózon",
  "airQuality.pm10": "10 μm-nél kisebb részecske",
  "airQuality.pm25": "2,5 μm-nél kisebb részecske",
  "airQuality.sensitiveUnhealthy": "Rossz az érzékeny csoportoknak",
  "airQuality.sensitiveUnhealthyDescription": "A levegő minősége elfogadható; Egyes szennyező anyagok azonban mérsékelt egészségügyi aggodalmat jelenthetnek nagyon kis számú, a légszennyezésre különösen érzékeny ember számára.",
  "airQuality.so2": "A kén-dioxid",
  "airQuality.unhealthy": "Rossz",
  "airQuality.unhealthyDescription": "Bárki érezheti az egészségügyi hatásokat; az érzékeny csoportok tagjai súlyosabb egészségügyi hatásokat tapasztalhatnak.",
  "airQuality.veryUnhealthy": "Nagyon rossz",
  "airQuality.veryUnhealthyDezscription": "Egészségügyi figyelmeztetések vészhelyzetekre. Valószínűbb, hogy az egész lakosságot érinti.",
  "alerts.addAlert": "Figyelmeztetés hozzáadása",
  "alerts.addCondition": "Feltétel hozzáadása",
  "alerts.alertAdded": "A figyelmeztetés sikeresen hozzáadva",
  "alerts.alertAuthorizationNotice": "A riasztások csak akkor működnek, ha engedélyezi a SmartMixin számára az értesítések megjelenítését",
  "alerts.alertDeleted": "A figyelmeztetés sikeresen törölve",
  "alerts.alertEdited": "A figyelmeztetés sikeresen módosítva",
  "alerts.alertName": "Figyelmeztető név",
  "alerts.alertWhen": "riasztani akarok",
  "alerts.aqiGreaterThan": "AQI nagyobb, mint",
  "alerts.aqiGreaterThanThreshold": "Az AQI {value}{unit} küszöbérték felett van",
  "alerts.aqiLessThan": "AQI kevesebb, mint",
  "alerts.aqiLessThanThreshold": "Az AQI {value}{unit} küszöb alatt van",
  "alerts.atLeastOneCondition": "Legalább egy feltételt hozzá kell adni",
  "alerts.co2GreaterThan": "CO2 nagyobb, mint",
  "alerts.co2GreaterThanThreshold": "CO2 a(z) {value}{unit} küszöbérték felett",
  "alerts.co2LessThan": "CO2 kevesebb, mint",
  "alerts.co2LessThanThreshold": "CO2 a(z) {value}{unit} küszöb alatt",
  "alerts.conditions": "Feltételek",
  "alerts.createAlert": "Figyelmeztetés létrehozása",
  "alerts.dailyPrecipitationGreaterThan": "Napi csapadék nagyobb, mint",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Napi csapadék meghaladja a {value}{unit} küszöbértéket",
  "alerts.deleteAlert": "Figyelmeztetés törlése",
  "alerts.editAlert": "Figyelmeztetés szerkesztése",
  "alerts.editCondition": "Állapot módosítása",
  "alerts.gustSpeedGreaterThan": "A széllökés nagyobb, mint",
  "alerts.gustSpeedGreaterThanThreshold": "Sorozatfelvétel {value}{unit} küszöb felett",
  "alerts.gustSpeedLessThan": "A széllökések kisebbek, mint",
  "alerts.gustSpeedLessThanThreshold": "Sorozatkép {value}{unit} küszöb alatt",
  "alerts.heatIndexGreaterThan": "Hőindex több, mint",
  "alerts.heatIndexGreaterThanThreshold": "A Hőindex meghaladja a {value}{unit} küszöbértéket",
  "alerts.heatIndexLessThan": "Hőindex kevesebb, mint",
  "alerts.heatIndexLessThanThreshold": "A Hőindex {value}{unit} küszöb alatt van",
  "alerts.humidexGreaterThan": "Humidex több, mint",
  "alerts.humidexGreaterThanThreshold": "A Humidex meghaladja a {value}{unit} küszöbértéket",
  "alerts.humidexLessThan": "Humidex kevesebb, mint",
  "alerts.humidexLessThanThreshold": "A Humidex {value}{unit} küszöb alatt van",
  "alerts.humidityGreaterThan": "Páratartalom fent",
  "alerts.humidityGreaterThanThreshold": "A páratartalom meghaladja a {value}{unit} küszöbértéket",
  "alerts.humidityLessThan": "Páratartalom lent",
  "alerts.humidityLessThanThreshold": "A páratartalom {value}{unit} küszöb alatt van",
  "alerts.inProgress": "Folyamatban",
  "alerts.myAlerts": "Saját figyelmeztetéseim",
  "alerts.noConfiguredAlert": "Még nincs figyelmeztetése, adjon hozzá egyet",
  "alerts.noiseGreaterThan": "Zaj nagyobb, mint",
  "alerts.noiseGreaterThanThreshold": "Zaj meghaladja a(z) {value}{unit} küszöbértéket",
  "alerts.noiseLessThan": "Zaj kisebb, mint",
  "alerts.noiseLessThanThreshold": "Zaj {value}{unit} küszöb alatt",
  "alerts.noteOnConditions": "Vegye figyelembe, hogy a riasztás akkor aktiválódik, ha az alábbi feltételek mindegyike érvényesül",
  "alerts.pm10GreaterThan": "PM 10 nagyobb, mint",
  "alerts.pm10GreaterThanThreshold": "PM 10 {value}{unit} küszöbérték felett",
  "alerts.pm10LessThan": "PM 10 kevesebb mint",
  "alerts.pm10LessThanThreshold": "PM 10 {value}{unit} küszöb alatt van",
  "alerts.pm1GreaterThan": "PM 1 nagyobb, mint",
  "alerts.pm1GreaterThanThreshold": "PM 1 a {value}{unit} küszöbérték felett",
  "alerts.pm1LessThan": "PM 1 kevesebb mint",
  "alerts.pm1LessThanThreshold": "PM 1 a {value}{unit} küszöb alatt van",
  "alerts.pm2p5GreaterThan": "PM 2,5 nagyobb, mint",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 a {value}{unit} küszöbérték felett",
  "alerts.pm2p5LessThan": "PM 2,5 kevesebb, mint",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 a {value}{unit} küszöb alatt",
  "alerts.postStormSummary": "Esőzés összegzése",
  "alerts.postStormSynopsisHelper": "Minden esőzés végén összegző értesítést kap.",
  "alerts.postStormSynopsisSoleCondition": "",
  "alerts.precipitationGreaterThan": "Óránkénti csapadék nagyobb, mint",
  "alerts.precipitationGreaterThanThreshold": "Óránkénti csapadék meghaladja a {value}{unit} küszöbértéket",
  "alerts.pressureGreaterThan": "Nyomás nagyobb, mint",
  "alerts.pressureGreaterThanThreshold": "Nyomás a(z) {value}{unit} küszöbérték felett",
  "alerts.pressureLessThan": "Nyomás kisebb, mint",
  "alerts.pressureLessThanThreshold": "A nyomás {érték}{unit} küszöb alatt van",
  "alerts.rainRateGreaterThan": "Eső intenzitása nagyobb, mint",
  "alerts.rainRateGreaterThanThreshold": "Eső intenzitása meghaladja a {value}{unit} küszöbértéket",
  "alerts.solarRadiationGreaterThan": "A napsugárzás nagyobb, mint",
  "alerts.solarRadiationGreaterThanThreshold": "A napsugárzás meghaladja a {value}{unit} küszöbértéket",
  "alerts.solarRadiationLessThan": "A napsugárzás kevesebb, mint",
  "alerts.solarRadiationLessThanThreshold": "A napsugárzás {value}{unit} küszöbérték alatt van",
  "alerts.temperatureGreaterThan": "Fölötti hőmérséklet",
  "alerts.temperatureGreaterThanThreshold": "A hőmérséklet meghaladja a {value}{unit} küszöbértéket",
  "alerts.temperatureLessThan": "Hőmérséklet lent",
  "alerts.temperatureLessThanThreshold": "A hőmérséklet {value}{unit} küszöb alatt van",
  "alerts.thswGreaterThan": "THSW több, mint",
  "alerts.thswGreaterThanThreshold": "A THSW meghaladja a {value}{unit} küszöbértéket",
  "alerts.thswLessThan": "THSW kevesebb, mint",
  "alerts.thswLessThanThreshold": "A THSW {value}{unit} küszöb alatt van",
  "alerts.thwGreaterThan": "THW több, mint",
  "alerts.thwGreaterThanThreshold": "A THW meghaladja a {value}{unit} küszöbértéket",
  "alerts.thwLessThan": "THW kevesebb, mint",
  "alerts.thwLessThanThreshold": "A THW {value}{unit} küszöb alatt van",
  "alerts.uvGreaterThan": "UV nagyobb, mint",
  "alerts.uvGreaterThanThreshold": "UV a {value}{unit} küszöbérték felett",
  "alerts.uvLessThan": "UV alacsonyabb, mint",
  "alerts.uvLessThanThreshold": "UV a {value}{unit} küszöb alatt",
  "alerts.visibilityGreaterThanThreshold": "A láthatóság {value}{unit} küszöb alatt van",
  "alerts.visibilityLessThanThreshold": "A láthatóság {value}{unit} küszöb alatt van",
  "alerts.visiblityGreaterThan": "Láthatósága kisebb, mint",
  "alerts.visiblityLessThan": "Láthatósága kisebb, mint",
  "alerts.whichMeasure": "Milyen intézkedésre szeretne figyelmeztetést kapni?",
  "alerts.whichModule": "Melyik modulra szeretne figyelmeztetni?",
  "alerts.windChillGreaterThan": "Szélhűtés több, mint",
  "alerts.windChillGreaterThanThreshold": "A Szélhűtés meghaladja a {value}{unit} küszöbértéket",
  "alerts.windChillLessThan": "Szélhűtés kevesebb, mint",
  "alerts.windChillLessThanThreshold": "A Szélhűtés {value}{unit} küszöb alatt van",
  "alerts.windSpeedGreaterThan": "A szél nagyobb mint",
  "alerts.windSpeedGreaterThanThreshold": "Szél {value}{unit} küszöb felett",
  "alerts.windSpeedLessThan": "A szél kisebb, mint",
  "alerts.windSpeedLessThanThreshold": "A szél {value}{unit} küszöb alatt van",
  "astral.astronomicalSunPhase": "{sunPhase} csillagászati",
  "astral.civilSunPhase": "{sunPhase} civil",
  "astral.dawn": "Hajnal",
  "astral.dusk": "Szürkület",
  "astral.firstQuarter": "első negyedévben",
  "astral.fullMoon": "Telihold",
  "astral.lastQuarter": "Utolsó negyed",
  "astral.moon": "Hold",
  "astral.moonPhases": "Holdfázisok",
  "astral.moonrise": "Holdkelte",
  "astral.moonset": "Napnyugta",
  "astral.nauticalSunPhase": "{sunPhase} tengeri",
  "astral.newMoon": "Újhold",
  "astral.noon": "Dél",
  "astral.remainingDaylight": "Maradt nappali fény",
  "astral.sunrise": "Napkelte",
  "astral.sunriseAndSunset": "Napkelte és napnyugta",
  "astral.sunriseAt": "Napkelte: {time}",
  "astral.sunset": "Napnyugta",
  "astral.sunsetAt": "Napnyugta: {time}",
  "astral.totalDaylight": "Teljes nappali fény",
  "astral.waningCrescent": "Utolsó félhold",
  "astral.waningGibbous": "Csökkenő zúgó hold",
  "astral.waxingCrescent": "Első Félhold",
  "astral.waxingGibbous": "Növekvő Hold",
  "auth.alreadyHaveAccount": "Már van fiókja?",
  "auth.authContainerTagline": "Személyes időjárás műszerfal. Csatlakoztassa állomásait, és valós idejű adatokat kapjon kéznél.",
  "auth.backToLogin": "Vissza a bejelentkezéshez",
  "auth.catchPhrase": "The Weather Intelligence Platform",
  "auth.checkYourEmail": "Ellenőrizze e-mailjét",
  "auth.continueWithApple": "Folytatás Apple-lel",
  "auth.continueWithFacebook": "Folytatás Facebook-kal",
  "auth.continueWithGoogle": "Folytatás Google-lel",
  "auth.email": "E-mail cím",
  "auth.emailRequiredLoginFacebook": "Email jóváhagyás szükséges a Facebook-bejelentkezéshez",
  "auth.emailVerification": "Email megerősítés",
  "auth.emailVerificationFailure": "Hiba történt az e-mail-cím ellenőrzése során.",
  "auth.emailVerificationSuccess": "E-mail-címét sikeresen ellenőriztük.",
  "auth.firstName": "Keresztnév",
  "auth.forgotPassword": "Elfelejtett jelszó",
  "auth.forgotPasswordSubtitle": "Adja meg e-mail címét, és küldünk egy linket a jelszó visszaállításához.",
  "auth.lastName": "Vezetéknév",
  "auth.login": "Bejelentkezés",
  "auth.loginSubtitle": "Üdvözöljük újra! Kérjük, adja meg adatait.",
  "auth.loginToSmartMixinDescription": "Adja meg SmartMixin hitelesítő adatait a fiók eléréséhez.",
  "auth.logout": "Kijelentkezés",
  "auth.logoutConfirmation": "Biztosan le akarja bontani a kapcsolatot?",
  "auth.noAccountYet": "Még nincs fiókja?",
  "auth.or": "vagy",
  "auth.password": "Jelszó",
  "auth.passwordAgain": "Jelszó megerősítése",
  "auth.passwordReset": "Jelszó visszaállítása",
  "auth.passwordResetSuccess": "Sikeres jelszó-visszaállítás.",
  "auth.register": "Regisztráció",
  "auth.registerDescription": "Hozzon létre ingyenes SmartMixin fiókot az időjárás-állomások csatlakoztatásához, időjárási adatok nyomon követéséhez és hatékony elemzési eszközök eléréséhez.",
  "auth.registerSubtitle": "Hozza létre fiókját a kezdéshez.",
  "auth.registerSuccess": "Sikeres regisztráció! Egy ellenőrző linket küldtünk neked a(z) {emailAddress} címen a további utasításokkal.",
  "auth.restorePassword": "Jelszó visszaállítása",
  "auth.restorePasswordSuccess": "Küldtünk egy linket a jelszó visszaállításához a(z) {emailAddress} címre a további utasításokkal.",
  "auth.sendReset": "Helyreállítási adatok küldése",
  "auth.socialAccount": "vagy használd valamelyik közösségi profilod",
  "auth.welcome": "Üdvözöl a SmartMixin",
  "auth.welcomeBack": "Üdvözlünk!",
  "calendar.april": "Április",
  "calendar.august": "Augusztus",
  "calendar.dateFormat": "dátum formátum",
  "calendar.day": "Nap",
  "calendar.december": "December",
  "calendar.end": "Vége",
  "calendar.february": "Február",
  "calendar.hours": "óra",
  "calendar.hoursShort": "h",
  "calendar.january": "Január",
  "calendar.july": "Július",
  "calendar.june": "Június",
  "calendar.last24Hours": "elmúlt 24 óra",
  "calendar.last30Days": "elmúlt 30 nap",
  "calendar.last7Days": "elmúlt 7 nap",
  "calendar.march": "Március",
  "calendar.max": "Max",
  "calendar.may": "Május",
  "calendar.month": "Hónap",
  "calendar.months": "hónapok",
  "calendar.november": "November",
  "calendar.october": "Október",
  "calendar.oneDay": "1 nap",
  "calendar.oneHour": "1 óra",
  "calendar.oneMonth": "1 hónap",
  "calendar.oneWeek": "1 hét",
  "calendar.previous24Hours": "Az előző 24 óra",
  "calendar.previous30Days": "Az előző 30 nap",
  "calendar.previous7Days": "Az előző 7 nap",
  "calendar.previousDay": "Tegnapi nappal",
  "calendar.previousMonth": "Előző hónappal",
  "calendar.previousWeek": "Előző héttel",
  "calendar.previousYear": "Tavalyi év",
  "calendar.sameDayLastYear": "Tavaly ugyanezzel a nappal",
  "calendar.sameMonthLastYear": "Tavaly ugyanezzel a hónappal",
  "calendar.selectADate": "Válasszon ki egy dátumot",
  "calendar.selectAMonth": "Válasszon egy hónapot",
  "calendar.selectAYear": "Válasszon egy évet",
  "calendar.selectGranularity": "Válassz részletességet",
  "calendar.selectTimescale": "Időtáv választása",
  "calendar.september": "Szeptember",
  "calendar.sixHours": "6 óra",
  "calendar.start": "Kezdet",
  "calendar.thirtyMinutes": "30 perc",
  "calendar.threeHours": "3 óra",
  "calendar.use24HourFormat": "Használjon 24 órás formátumot",
  "calendar.week": "Hét",
  "calendar.year": "Év",
  "calendar.yesterday": "Tegnap",
  "common.accountDeleted": "Fiókját sikeresen töröltük.",
  "common.accountOnHold": "A fiókkapcsolat lejárt. Kérjük, csatlakozzon újra az adatfrissítések folytatásához.",
  "common.add": "Hozzáadás",
  "common.addAStation": "Állomás hozzáadása",
  "common.addToFavorites": "Add hozzá a kedvencekhez",
  "common.addYourOwnStation": "Adja hozzá az állomását",
  "common.alreadyPremium": "Már van prémium előfizetésed!",
  "common.alsoAvailableOn": "Elérhető még:",
  "common.altitude": "Magasság",
  "common.analysis": "Elemzés",
  "common.aroundMe": "Körülöttem",
  "common.articleCount": "{count} cikk",
  "common.articleNotFound": "A cikk nem található",
  "common.articleNotFoundDescription": "A keresett cikk nem létezik.",
  "common.average": "Megfelelő",
  "common.averageOverThePeriod": "Időszakos átlag",
  "common.away": "Távollét",
  "common.back": "Vissza",
  "common.backToHelpCenter": "Vissza a súgóközpontba",
  "common.backToHome": "Vissza a Főoldalra",
  "common.bad": "Rossz",
  "common.batteryLevel": "Akkumulátor töltöttsége",
  "common.bestValue": "Legjobb Érték",
  "common.billingDetailsAndroid": "A próbaverziós előfizetésért nem számítunk fel díjat, ha az ingyenes bevezető időszak lejárta előtt 24 órával lemondásra kerül. A próbaidőszak lejárta után is bármikor lemondható a SmartMixin-előfizetés a Google Play-fiók beállításaiban, egyébként pedig automatikusan megújításra kerül. Ezt legkésőbb 24 órával az előfizetési időszak vége előtt kell megtenni, hogy elkerüljük további díjak felszámítását. A kifizetéseket a Google Play-számládra terheljük a vásárlás visszaigazolásakor, ill. a megújítás során.",
  "common.billingDetailsIos": "A próbaverziós előfizetésért nem számítunk fel díjat, ha az ingyenes bevezető időszak lejárta előtt 24 órával lemondásra kerül. A próbaidőszak lejárta után is bármikor lemondható a SmartMixin-előfizetés az App Store-fiók beállításaiban, egyébként pedig automatikusan megújításra kerül. Ezt legkésőbb 24 órával az előfizetési időszak vége előtt kell megtenni, hogy elkerüljük további díjak felszámítását. A kifizetéseket az App Store-számládra terheljük a vásárlás visszaigazolásakor, ill. a megújítás során.",
  "common.boilerOn": "Kazán aktivitás",
  "common.browseByCategory": "Böngészés kategória szerint",
  "common.calendarView": "Naptár nézet",
  "common.cancel": "Mégse",
  "common.cannotBeEmpty": "Ez a mező nem lehet üres.",
  "common.cardDetails": "Kártya adatai",
  "common.categoryNotFound": "Kategória nem található",
  "common.categoryNotFoundDescription": "Ez a kategória nem létezik vagy nincsenek benne cikkek.",
  "common.charts": "Grafikonok",
  "common.chartView": "Diagram nézet",
  "common.clearRecentLocations": "Tisztítsa meg az összeset",
  "common.close": "Bezárás",
  "common.comparison": "Összehasonlítás",
  "common.currentDay": "Ma",
  "common.currentLocation": "Aktuális hely",
  "common.currentObservations": "Legújabb észlelések",
  "common.currentRainEvent": "Aktuális esőesemény",
  "common.currentRate": "Eső intenzitása",
  "common.currentWeatherConditions": "Aktuális feltételek",
  "common.customizeComparisonMetrics": "Összehasonlítási mutatók testreszabása",
  "common.customizeComparisonMetricsDescription": "Húzza az elemeket az összehasonlítási mutatók átrendezéséhez. Koppintson a szem ikonra a mutatók megjelenítéséhez vagy elrejtéséhez.",
  "common.customizeDashboard": "Testreszabás",
  "common.customizeDashboardDescription": "Húzza az elemeket az irányítópult átrendezéséhez. Koppintson a szem ikonra a szakaszok megjelenítéséhez vagy elrejtéséhez.",
  "common.customizedStationName": "Egyéni állomásnév",
  "common.dailyForecast": "Napi előrejelzés",
  "common.dashboard": "Irányítópult",
  "common.default": "Alapértelmezett",
  "common.defaultForecastModelChip": "Alapértelmezett · {name}",
  "common.delete": "TÖRÖL",
  "common.deleteAccount": "Fiók törlése",
  "common.deleteAccountConfirmation": "Biztosan törölni szeretné fiókját? Ez a művelet visszafordíthatatlan.",
  "common.deleteAccountDescription": "Ez a művelet törli fiókját és minden adatát. Nincs visszaút.",
  "common.details": "Részletek",
  "common.edit": "Szerkesztés",
  "common.editor": "Szerkesztő",
  "common.endTime": "VÉGE",
  "common.exitFullscreen": "",
  "common.exploreWeatherMap": "Időjárási Térkép Felfedezése",
  "common.favoriteLocations": "Kedvencek",
  "common.favoriteLocationsEmpty": "Legfeljebb 5 kedvenc helyet adhat hozzá.",
  "common.favoriteStations": "Kedvenc állomások",
  "common.feedbackHelpsImprove": "Visszajelzése segít nekünk javítani súgócikkeinket.",
  "common.filterStationDescription": "Ne jelenjen meg megbízhatatlan mértékű állomás",
  "common.filterStations": "Szűrés állomások",
  "common.filterStationSourceDescription": "Válassza ki azokat az állomásszolgáltatókat, amelyeket meg szeretne jeleníteni a térképen",
  "common.findStationsNearYou": "Állomások keresése a közelben",
  "common.firmwareVersion": "Firmware verzió",
  "common.forecast": "Előrejelzés",
  "common.forecastComparisonDescription": "Könnyen összehasonlíthatja a különböző rendelkezésre álló időjárási modellek adatait",
  "common.forecastModelComparison": "Az időjárási modellek összehasonlítása",
  "common.forecastModelCoverage": "Lefedettség",
  "common.forecastModelDescription": "Leírás",
  "common.forecastModelDescription_AROME": "A Météo France konvekciót feloldó nagy felbontású modellje Nyugat-Európa felett 1,3 km felbontással. A legjobb a maga kategóriájában a franciaországi rövid távú előrejelzésekhez; háromóránként frissül.",
  "common.forecastModelDescription_ARPEGE_EU": "A Météo France ARPEGE modelljének európai fészke 10 km felbontással. Középtávú előrejelzések Európa felett, naponta négyszer frissülnek.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "A Météo France globális numerikus időjárási modellje 25 km felbontással, kb. 4 napig fut. Naponta négyszer frissül.",
  "common.forecastModelDescription_EC_GDPS": "Az Environment Canada Globális Determinisztikus Előrejelző Rendszere: globális középtávú modell 15 km felbontással, 10 napig fut, naponta kétszer frissül.",
  "common.forecastModelDescription_EC_RDPS": "Az Environment Canada Regionális Determinisztikus Előrejelző Rendszere: középtávú modell Észak-Amerika felett 10 km felbontással, naponta négyszer frissül.",
  "common.forecastModelDescription_GFS": "A NOAA zászlóshajó középtávú globális modellje. Az egész bolygót lefedi 25 km felbontással, akár 16 napig, naponta négyszer frissül.",
  "common.forecastModelDescription_HRRR_CONUS": "A NOAA High-Resolution Rapid Refresh modellje: konvekciót feloldó modell az Egyesült Államok kontinentális területe felett 3 km felbontással, óránként frissül. Leginkább nagyon rövid távú zivatar- és extrém időjárás-előrejelzésekhez ajánlott.",
  "common.forecastModelDescription_ICON_DE": "A DWD nagy felbontású konvekciót feloldó modellje Németország és a környező országok felett 2,2 km felbontással. Rövid távú előrejelzések naponta kétszer frissülnek.",
  "common.forecastModelDescription_ICON_EU": "A DWD ICON modelljének európai fészke 7 km felbontással, Európát és az Észak-Atlanti-óceánt lefedi. Középtávú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_MET_NORWAY": "A Norvég Meteorológiai Intézet nyílt időjárás-előrejelző szolgáltatása, amely a nagy felbontású északi modelleket az ECMWF adataival kombinálja, hogy akár 10 napos globális előrejelzéseket biztosítson.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "AROME fészek a Francia Antillák felett (Guadeloupe, Martinique) 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "AROME fészek Francia Guyana felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "AROME fészek Új-Kaledónia felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "AROME fészek Francia Polinézia felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "AROME fészek Réunion és Mayotte felett 2,5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_NAM_CONUS": "A NOAA North American Mesoscale modellfészke az Egyesült Államok kontinentális területe felett 5 km felbontással. Rövid távú előrejelzések naponta négyszer frissülnek.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "A NOAA North American Mesoscale modellje, amely az egész Észak-Amerikát lefedi 32 km felbontással. Naponta négyszer frissül.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "A SmartMixin zászlóshajó előrejelzése. Az Ön helyén minden órára kiválasztjuk a legjobb elérhető modellt — általában egy nagy felbontású regionális modellt ott, ahol létezik (AROME Franciaországban, ICON-D2 Németországban, HRRR az Egyesült Államokban, ARPEGE Europe a kontinens egészén…) és máshol egy globális modellre térünk vissza — majd kitöltjük a hiányosságokat a szomszédos forrásokból. Az eredmény egyetlen zökkenőmentes előrejelzés, amely 14 napig lefedi a világon bárhol, és automatikusan frissül, amikor bármelyik alapul szolgáló modellt frissítik.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "A Weatherflow saját globális előrejelzése, amely több numerikus időjárási modellt kever a Tempest meteorológiai állomások hálózatának megfigyeléseivel. 10 napos globális horizont.",
  "common.forecastModelDetailTitle": "Előrejelzési modell",
  "common.forecastModelScopeGlobal": "Globális",
  "common.forecastModelScopeGlobalDescription": "Ez a modell az egész bolygót lefedi.",
  "common.forecastModelScopeRegional": "Regionális",
  "common.forecastModelScopeRegionalDescription": "Ez a modell csak egy adott régiót fed le.",
  "common.forecastModelSpecifications": "Műszaki adatok",
  "common.forecastSources": "Előrejelzési források",
  "common.freeAccount": "Ingyenes számla",
  "common.freeSubscription": "Ingyenes előfizetés",
  "common.freeTrialForPeriod": "Ingyenes próbaidőszak {period} napig",
  "common.frequency": "Frekvencia",
  "common.full": "Teljes",
  "common.fullscreen": "",
  "common.getStartedFree": "Ingyenes Indulás",
  "common.getUnlimitedAccess": "Korlátlan hozzáférés:",
  "common.good": "Jó",
  "common.help": "Súgó",
  "common.helpCategoryAccount": "Fiók",
  "common.helpCategoryBilling": "Számlázás",
  "common.helpCategoryGettingStarted": "Első lépések",
  "common.helpCategoryProviders": "Szolgáltatók",
  "common.helpCategoryStations": "Állomások",
  "common.helpCategoryTroubleshooting": "Hibaelhárítás",
  "common.helpCenter": "Súgóközpont",
  "common.helpCenterDescription": "Találjon válaszokat a gyakori kérdésekre, és ismerje meg, hogyan hozhatja ki a legtöbbet a SmartMixinből.",
  "common.hg": "Fagyvédelem",
  "common.hidden": "Rejtett",
  "common.hiddenSensors": "Rejtett érzékelők",
  "common.hiddenStations": "Rejtett állomások",
  "common.hiddenStationsDescription": "Az állomást úgy lehet megsemmisíteni, hogy megcsapja a szem ikonját mellette.",
  "common.high": "Magas",
  "common.home": "Otthon",
  "common.homeConnectService": "Van időjárás-állomásod? Csatlakoztasd a szolgáltatásod",
  "common.homeInformation": "Otthoni információk",
  "common.homeIntroduction": "Kapcsolódj össze külső fiókjaiddal a SmartMixin szolgáltatásainak használatához.",
  "common.homeName": "Otthoni név",
  "common.homeSubtitle": "Az időjárásod, minden egy helyen",
  "common.horizon": "Horizon",
  "common.horizonValue": "legfeljebb {value} óra",
  "common.iDontKnowYet": "Még nem tudom",
  "common.indoor": "Beltér",
  "common.lastRainEvent": "Utolsó esős esemény",
  "common.lastUpdate": "Utolsó frissítés",
  "common.loading": "Betöltés",
  "common.location": "Hely",
  "common.locationAddedToFavorites": "Helyszín hozzáadva a kedvencekhez",
  "common.locationNotGranted": "A helymeghatározási engedély nem adható meg. Kérjük, hagyja, hogy az eszközbeállításokban hozzáférhessen a tartózkodási helyhez.",
  "common.locationRemovedFromFavorites": "Helyet eltávolítva a kedvencektől",
  "common.locations": "Helyek",
  "common.low": "Alacsony",
  "common.manage": "Kezelés",
  "common.manageAccount": "Fiók kezelése",
  "common.manageMySubscription": "Előfizetés megtekintése",
  "common.manageSensors": "Érzékelők kezelése",
  "common.manageSensorsDescription": "Húzza az elemeket az érzékelők átrendezéséhez. Koppintson a szem ikonra az érzékelők megjelenítéséhez vagy elrejtéséhez. Koppintson egy névre az átnevezéshez.",
  "common.manualBoost": "Manuális szabályzás",
  "common.manualSetpointUntil": "Manuális alapjel egészen",
  "common.maxFavoriteLocationsReached": "Csak 5 kedvenc helye lehet. Távolítsa el az egyiket a másik hozzáadásához.",
  "common.measureToDisplay": "Mérje meg a megjelenítéshez",
  "common.medium": "Közepes",
  "common.meshSize": "Rács mérete",
  "common.minRead": "{minutes} perc olvasás",
  "common.modifyFavoriteStations": "Módosítsa a kedvenc állomásait",
  "common.modifyFavoriteStationsDescription": "Átrendezheti kedvenc állomásait azáltal, hogy húzza őket. A listáról is eltávolíthatja őket.",
  "common.moduleType": "Modultípus",
  "common.monthTotal": "Ebben a hónapban",
  "common.more": "Egyéb",
  "common.moreInformation": "További információ",
  "common.myLocation": "Saját hely",
  "common.nearbyWeatherStations": "Közeli időjárási állomások",
  "common.next": "Következő",
  "common.nextHours": "Órák jönnek",
  "common.no": "Nem",
  "common.noAccountNeeded": "Nincs szükség fiókra",
  "common.noDataForThisPeriod": "Nincs adat a választott időszakban",
  "common.noLocationsFound": "Nem található hely",
  "common.noNetatmoWeatherStationYet": "Jelenleg nem kapcsolódsz egyetlen időjárás állomáshoz sem.",
  "common.noOutdoorModule": "Ehhez az állomáshoz nincs működő kültéri modul.",
  "common.noStationsFound": "Nem található állomás",
  "common.noThermostatYet": "Jelenleg nem kapcsolódsz egyetlen termosztáthoz sem ..",
  "common.notNow": "Most nem",
  "common.notPurchasedYet": "Úgy tűnik, még nem vásároltad meg ezt a funckiót.",
  "common.noWeatherStation": "Nincs meteorológiai állomás",
  "common.noWeatherStationYet": "Jelenleg nem kapcsolódsz egyetlen időjárás állomáshoz sem.",
  "common.numberOfActiveWarnings": "{warning_count} aktív időjárási figyelmeztetések",
  "common.openSettings": "Nyissa meg a beállításokat",
  "common.orChooseMonthly": "Vagy válassz havi előfizetést:",
  "common.outdatedModule": "Ennek az egységnek az adatai elavultak.",
  "common.outdoor": "Kültér",
  "common.outdoorTemperature": "Kültéri hőmérséklet",
  "common.pageNotFound": "Az Oldal Nem Található",
  "common.pageNotFoundDescription": "A keresett oldal nem létezik vagy áthelyezték.",
  "common.passwordUpdated": "A jelszó sikeresen frissítve.",
  "common.personalWeatherIntelligence": "Személyes Időjárás Intelligenciád",
  "common.premiumAccount": "Prémium fiók",
  "common.premiumDescription": "Prémium előfizetéssel lehetővé válik időjárási adataid részletes elemezése, grafikonos összehasonlítások készítése, regionális szolgáltatók kiválasztása az előrejelzéshez, stb.",
  "common.premiumFeatureAlerts": "Időjárási Riasztások",
  "common.premiumFeatureAnalysis": "Fejlett Időjárás Elemzés",
  "common.premiumFeatureCharts": "Grafikon Összehasonlítások",
  "common.premiumFeatureExport": "Adatexportálás",
  "common.premiumFeatureForecast": "Regionális Előrejelzési Modellek",
  "common.premiumFeatureNotification": "Állapotsáv Widget",
  "common.premiumFeatureTitle": "Prémium Funkció",
  "common.premiumFeatureWidgets": "Kezdőképernyő widgetek",
  "common.pressureSummary": "A nyomás szintézise",
  "common.previous": "Előző",
  "common.previousHours": "Korábbi órák",
  "common.profileUpdated": "Adataid sikeresen frissítve.",
  "common.purchasedNetatmoPro": "Ön korábban megvásárolta a Netatmo Pro ({date}). Iratkozzon fel az alábbi ajánlatok egyikére, hogy hozzáférjen az alkalmazás összes prémium funkciójához.",
  "common.rain": "Csapadék",
  "common.rainEvents": "Esős",
  "common.rainfallMeasurement": "Csapadékmérés",
  "common.rainRadar": "esőradar",
  "common.rainRadarDescription": "Jelenítse meg az esőradar fedvényét a térképen",
  "common.rainSummary": "A csapadék összegzése",
  "common.range": "Tartomány",
  "common.recentLocations": "Legújabb",
  "common.recentLocationsEmpty": "A közelmúlt története üres.",
  "common.recentStations": "Legutóbbi állomások",
  "common.relatedArticles": "Kapcsolódó cikkek",
  "common.relay": "Ütemező",
  "common.removeFromFavorites": "Törlés a kedvencek közül",
  "common.renameSensors": "Érzékelők átnevezése",
  "common.resetZoom": "Nagyítás visszaállítása",
  "common.restorePurchase": "Licensz visszaállítása",
  "common.room": "Szoba",
  "common.rooms": "Szobák",
  "common.savingsPercent": "Megtakarítás {percent}%",
  "common.searchArticles": "Cikkek keresése...",
  "common.searchForALocation": "Hely keresése...",
  "common.searchForLocation": "Találj egy helyet",
  "common.searchForWeatherStation": "Keressen egy meteorológiai állomást",
  "common.searchResults": "Keresési eredmények",
  "common.searchResultsEmpty": "Nincs eredmény.",
  "common.searchStationsDescription": "Adjon meg egy várost, címet vagy helynevet a közeli időjárás-állomások megtalálásához.",
  "common.searchStationsHint": "Használja a fenti keresősávot, hogy felfedezze az időjárás-állomásokat a világ bármely pontján.",
  "common.selectStationForComparison": "Válassza ki az állomást az összehasonlításhoz",
  "common.selectWeatherForecastProvider": "Időjárási adatszolgáltató választása",
  "common.serialNumber": "MAC-cím",
  "common.share": "Ossza meg",
  "common.shareOutdoorMeasures": "Ossza meg kültéri méreteit",
  "common.shareOutdoorMeasuresDescription": "Vegyen részt a SmartMixin közösségben külső adatainak megosztásával. A beltéri modulok adatai soha nem lesznek megosztva.",
  "common.shareYourWeather": "Ossza meg időjárását",
  "common.signalStrength": "Jelerősség",
  "common.skip": "Kihagyás",
  "common.smartThermostat": "Okos termosztát",
  "common.smartValve": "Okos radiátorszelep",
  "common.snow": "Hó",
  "common.start": "Indul",
  "common.startFreeTrial": "Ingyenes Próba Indítása",
  "common.startTime": "Kezdet",
  "common.station": "állomás",
  "common.stationAddedToFavorites": "Az állomás hozzáadva a kedvencekhez",
  "common.stationComparison": "Állomások összehasonlítása",
  "common.stationComparisonDescription": "Lehetővé teszi a korábbi időjárási adatok összehasonlítását egy másik állomás adataival.",
  "common.stationInformation": "Állomás adatok",
  "common.stationName": "Állomás neve",
  "common.stationObservationsDescription": "Megjeleníti az időjárási állomások legfrissebb megfigyelését",
  "common.stationRemovedFromFavorites": "Az állomás eltávolítva a kedvencek közül",
  "common.stations": "állomások",
  "common.stationsNear": "Állomások a közelben",
  "common.stationType": "állomás típusa",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Elavult",
  "common.statusSyncing": "Szinkronizálás",
  "common.subscribeNow": "Feliratkozás most - próbaidő nélkül",
  "common.sumOverThePeriod": "Az időszakban összesen",
  "common.switchToPremium": "SmartMixin Premium előfizetés",
  "common.temperatureShort": "Hőm.",
  "common.temperatureSummary": "Hőmérséklet összefoglaló",
  "common.thankYouForFeedback": "Köszönjük a visszajelzést!",
  "common.thenPrice": "majd {price}",
  "common.timeSelection": "Idő kiválasztása",
  "common.timezone": "Időzóna",
  "common.totalDuration": "Teljes időtartam",
  "common.tryAnotherLocation": "Nem találtunk időjárás-állomásokat e hely közelében. Próbáljon meg egy másik területen keresni.",
  "common.unknown": "Ismeretlen",
  "common.untilChanged": "Amíg nem változott",
  "common.untilTime": "Egészen {time}",
  "common.upgrade": "Frissítés",
  "common.upgradeRequiredAndroid": "Az alkalmazás frissítésére van szükség. Látogass el a Google Playre a frissítéshez.",
  "common.upgradeRequiredIos": "Az alkalmazás frissítésére van szükség. Lépj be az alkalmazásboltba.",
  "common.validate": "Érvényesítés",
  "common.validEmail": "Érvényes e-mail cím szükséges.",
  "common.very_low": "Nagyon alacsony",
  "common.visitNetatmoWebsite": "Netatmo weboldalának felkeresése",
  "common.wasArticleHelpful": "Hasznos volt ez a cikk?",
  "common.weatherCondition": "Időjárási állapot",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "Az NC Rain egy további adatforrás, amelyet a Nearcast Technology által hajtott Tempest Weather System biztosít. Az NC Rain adatok a Tempest körüli átlagos csapadékmennyiség becslése a környék szintjén",
  "common.weatherForecastModels": "Időjárás-előrejelzési modellek",
  "common.weatherIntelligencePlatform": "Az Időjárás Intelligencia Platform",
  "common.weatherMap": "Meteorológiai térkép",
  "common.weatherMapMetaDescription": "A SmartMixin interaktív időjárási és radaros térképeket kínál a világ minden tájáról.",
  "common.weatherObservations": "Időjárási megfigyelések",
  "common.weatherStation": "Meteorológiai állomás",
  "common.weatherStations": "Meteorológiai állomások",
  "common.welcome": "Üdvözöl a SmartMixin!",
  "common.whenBackHome": "Mikor fogsz hazaérni?",
  "common.wifiStrength": "WiFi jelerősség",
  "common.wind": "Szél",
  "common.windMeasurement": "Szélmérés",
  "common.windSpeed": "Szélsebesség",
  "common.windSummary": "A szél szintézise",
  "common.yearToDate": "Idén",
  "common.yes": "Igen",
  "intro.locationDescription": "Engedélyezd a helymeghatározást, hogy pontos, pontosan a területedre szabott időjárás‑előrejelzéseket kapj — nincs több általános előrejelzés.",
  "intro.locationTitle": "Előrejelzések neked szabva",
  "intro.notificationDescription": "Kapcsold be az értesítéseket, hogy időben figyelmeztetéseket kapj a számodra fontos időjárás‑változásokról — eső, hó vagy extrém körülmények, amikor csak kell.",
  "intro.notificationsTitle": "Ne maradj le egy időjárás‑változásról sem",
  "intro.readyDescription": "Élvezd a pontos előrejelzéseket, valós idejű időjárás‑információkat és állomásadatokat a világ minden tájáról — egyetlen erőteljes alkalmazásban.",
  "intro.readyTitle": "Készen állsz!",
  "intro.welcomeDescription": "Hyperlokális előrejelzések az iparág legjobb meteorológiai ügynökségeitől — plusz hozzáférés több mint 40 000 időjárási állomáshoz világszerte, hogy lásd a tényleges körülményeket, jelenleg és múltban.",
  "intro.welcomeTitle": "Időjárás újragondolva",
  "landing.alerts": "Figyelmeztetések",
  "landing.alertsDescription": "Hozzon létre saját figyelmeztetéseket, és azonnal értesítést kapjon, amint aktiválódnak.",
  "landing.featureAlertsDescription": "Állíts be egyéni riasztásokat az általad fontosnak tartott feltételekre—hőmérséklet, szél, csapadék és több.",
  "landing.featureAlertsTitle": "Intelligens riasztások",
  "landing.featureAnalyticsDescription": "Merülj el az adataidban interaktív diagramokkal, egymás melletti összehasonlításokkal és trendanalízissel az alapvető metrikákon túl.",
  "landing.featureAnalyticsTitle": "Hatékony elemzések",
  "landing.featureExportDescription": "Töltsd le az adataidat CSV formátumban Excel elemzéshez, más rendszerekkel való integrációhoz vagy biztonsági mentéshez.",
  "landing.featureExportTitle": "Exportálás bárhová",
  "landing.featureForecastDescription": "Hasonlítsd össze több mint 10 időjárási modell előrejelzéseit, beleértve a GFS, ECMWF, ICON és további modelleket, hogy lásd melyik működik a legjobban a te helyszíneden.",
  "landing.featureForecastTitle": "Előrejelzés összehasonlítás",
  "landing.featureHistoryDescription": "Hozzáférés történelmi adatokhoz óránkénti, napi és havi skálán. Export CSV formátumba kutatáshoz vagy személyes archívumba.",
  "landing.featureHistoryTitle": "Gazdag előzmények",
  "landing.featureMultiBrandDescription": "Csatlakoztass állomásokat Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow és más márkáktól—minden egy irányítópulton.",
  "landing.featureMultiBrandTitle": "Több márka támogatás",
  "landing.featuresSubtitle": "Időjárás rajongóknak tervezve, akik többet várnak el egy egyszerű időjárás-állomás alkalmazásnál.",
  "landing.featuresTitle": "Minden, ami az időjárás elemzéséhez kell",
  "landing.finalCtaButton": "Ingyenes fiók létrehozása",
  "landing.finalCtaSubtitle": "Csatlakozz több ezer időjárás rajongóhoz, akik a SmartMixinre bízzák időjárási adataikat.",
  "landing.finalCtaTitle": "Készen állsz az időjárás élmény fejlesztésére?",
  "landing.forecastDescription": "Nézze meg a legjobb időjárás-előrejelzési modelleket, és hasonlítsa össze őket, hogy saját elképzelést kapjon arról, milyen lesz az időjárás.",
  "landing.forecasts": "Előrejelzések",
  "landing.heroCta": "Ingyenes kezdés",
  "landing.heroDescription": "Kombináld több időjárás-állomás adatait bármely márkától, hasonlítsd össze az előrejelzési modelleket és elemezd az adataidat részletes diagramokkal és exportálással.",
  "landing.heroSecondaryCta": "Funkciók megtekintése",
  "landing.heroTagline": "Minden időjárási adat. Egy platform.",
  "landing.heroTitle": "Minden időjárási adat. Egy platform.",
  "landing.pricingFeatureAdvancedMetrics": "Haladó mérőszámok",
  "landing.pricingFeatureAlerts": "Egyéni riasztások",
  "landing.pricingFeatureExport": "Adatexport (CSV)",
  "landing.pricingFeatureForecastComparison": "Előrejelzés-összehasonlítás",
  "landing.pricingFeatureForecasts": "Előrejelzési modellek",
  "landing.pricingFeatureForecastsFreeTier": "1 modell",
  "landing.pricingFeatureForecastsPremiumTier": "Minden modell (10+)",
  "landing.pricingFeatureReports": "Elemzések és jelentések",
  "landing.pricingFeatureStationComparison": "Állomás-összehasonlítás",
  "landing.pricingFeatureWidgets": "Kezdőképernyő widgetek",
  "landing.pricingFeatureYearOverYear": "Éves összehasonlító elemzés",
  "landing.pricingFree": "Ingyenes",
  "landing.pricingFreeCta": "Kezdés",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Legnépszerűbb",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Kezdje el",
  "landing.pricingPremiumDescription": "1,99 €/hónaptól — fizessen elő weben, App Store-ban vagy Google Playen",
  "landing.pricingSubtitle": "Kezdd ingyenesen, frissíts amikor többre van szükséged.",
  "landing.pricingTitle": "Egyszerű, átlátható árazás",
  "landing.smartMixinDescription": "A SmartMixin egy olyan alkalmazás, amely hozzáférést biztosít időjárási állomásához és több mint 40 ezer további állomáshoz világszerte. Segít meglátni és megérteni az időjárási adatokat.",
  "landing.statBrands": "Támogatott márkák",
  "landing.statForecasts": "Előrejelzési modellek",
  "landing.statStations": "Időjárás-állomások",
  "landing.supportedDevices": "Támogatott eszközök",
  "landing.supportedDevicesDescription": "A Meteorológiai Világszervezet állomásai mellett a SmartMixin egyre több időjárási állomás márkát támogat.",
  "landing.supportedDevicesNote": "Valamint több mint 40 000 nyilvános állomás a Meteorológiai Világszervezettől",
  "landing.supportedDevicesSubtitle": "Csatlakoztass időjárás-állomásokat vezető márkáktól és tekintsd meg az összes adatot egy helyen.",
  "landing.supportedDevicesTitle": "Működik az állomásaiddal",
  "landing.thermostatDescription": "Csatlakoztassa Netatmo termosztátját a fűtési minták és a kültéri körülmények összehasonlításához.",
  "landing.thermostatManufacturers": "A termosztátgyártók szintén támogatják a fűtés és a kültéri feltételek közötti összefüggést.",
  "landing.thermostatTitle": "Okosotthon-integráció",
  "landing.weatherAnalysis": "Időjárás elemzése",
  "landing.weatherAnalysisDescription": "A SmartMix számos adatvizualizációt tartalmaz, amelyek lehetővé teszik az időjárási adatok elemzését.",
  "landing.weatherAssistant": "Az Ön időjárási asszisztense",
  "landing.weatherAssistantDescription": "Akár aktuális, történelmi vagy előrejelzett időjárási viszonyok érdekelnek, a SmartMixin számos betekintést nyújt, amikor csak szüksége van rájuk.",
  "landing.weatherForecastModels": "Időjárás-előrejelzési modellek",
  "landing.weatherForecastModelsDescription": "A SmartMixin hozzáférést biztosít a legpontosabb időjárás-előrejelzési modellekhez. Könnyedén összehasonlíthatja előrejelzéseiket, és elkészítheti saját elképzeléseit.",
  "landing.weatherMap": "Időjárási térkép",
  "landing.weatherMapDescription": "Böngésszen a térképen, és képzelje el, milyen az időjárás bárhol a világon.",
  "network.cancelError": "Kérés visszavonva",
  "network.connectionError": "Szerver nem elérhető",
  "network.networkError": "Hálózat nem elérhető",
  "network.serverError": "Szerverhiba...",
  "network.timeoutError": "Kapcsolat időtúllépés",
  "network.unknownError": "Ismeretlen hiba",
  "providerHints.ambientWeatherApiKey": "Az ambientweather.net fiókbeállításaiban hozható létre.",
  "providerHints.davisApiSecret": "Csak egyszer látható a V2 API-kulcs létrehozásakor — őrizze meg biztonságosan.",
  "providerHints.davisV2ApiKey": "A weatherlink.com V2 API-kulcsok oldaláról.",
  "providerHints.ecowittApi": "Az Ecowitt fiók API-oldaláról.",
  "providerHints.ecowittApp": "Az alkalmazáskulcs, szintén az Ecowitt fiókjából.",
  "providerHints.myAcuriteCredentialsBanner": "Használja a My AcuRite-fiók e-mailjét és jelszavát — ne a SmartMixin-bejelentkezést.",
  "providerHints.myAcuriteEmail": "A My AcuRite-fiók e-mail címe — nem a SmartMixin-bejelentkezés.",
  "providerHints.myAcuritePassword": "A My AcuRite-fiók jelszava.",
  "providerHints.weatherflowToken": "Személyes token a tempestwx.com → beállítások → adatengedélyek menüpontból.",
  "providerHints.wundergroundEditKey": "Másik kulcs használata",
  "providerHints.wundergroundKey": "Egy hosszú karakterlánc a Weather Underground fiókjának API-kulcs oldaláról — nem a wunderground.com jelszava.",
  "providerHints.wundergroundKeyExample": "pl. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-kulcs ellenőrizve",
  "providerHints.wundergroundKeyVerifying": "Kulcs ellenőrzése…",
  "providerHints.wundergroundNoStationsNearby": "Nem található állomás a hely közelében. Próbálja meg közvetlenül megadni egy állomás azonosítóját.",
  "providerHints.wundergroundStationId": "Bármely Weather Underground állomás-azonosító — sajátja vagy a közelben lévő nyilvános állomás.",
  "providerHints.wundergroundStationIdExample": "pl. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Szerezze be Ambient Weather API-kulcsát.",
  "providerIntro.davisStep2": "Szerezze be Davis V2 API-kulcsát és API-titkát.",
  "providerIntro.ecowittStep2": "Szerezze be Ecowitt API-kulcsát és alkalmazáskulcsát.",
  "providerIntro.getStarted": "Indítás",
  "providerIntro.myAcuriteStep2": "Használja meglévő My AcuRite-fiókja e-mailjét és jelszavát.",
  "providerIntro.netatmoEnergyStep2": "Jelentkezzen be a Netatmóba, amikor a rendszer kéri — nincs szükség API-kulcsra.",
  "providerIntro.netatmoWeatherStep2": "Jelentkezzen be a Netatmóba, amikor a rendszer kéri — nincs szükség API-kulcsra.",
  "providerIntro.signupBanner": "Majdnem kész — hozzon létre egy ingyenes SmartMixin-fiókot a {provider} csatlakoztatásához.",
  "providerIntro.step1": "Jelentkezzen be a SmartMixin-fiókjába (NEM a {provider}-be).",
  "providerIntro.step3EmailPassword": "Adja meg itt.",
  "providerIntro.step3KeyOrToken": "Illessze be ide.",
  "providerIntro.step3OAuth": "Engedélyezze a SmartMixint a felugró ablakban.",
  "providerIntro.step3Wunderground": "Illessze be az API-kulcsát, majd válasszon egy közeli állomást, vagy adja meg bármely állomás azonosítóját.",
  "providerIntro.title": "{provider} csatlakoztatása",
  "providerIntro.weatherflowStep2": "Szerezze be személyes Tempest tokenjét.",
  "providerIntro.wundergroundBrowsePublic": "Nincs állomása? Tallózzon a nyilvánosak között",
  "providerIntro.wundergroundFindNearby": "Közeli állomások keresése",
  "providerIntro.wundergroundOrEnterId": "Vagy adja meg egy állomás azonosítóját",
  "providerIntro.wundergroundStep2": "Szerezze be Weather Underground API-kulcsát. Ezt követően bármilyen állomást csatlakoztathat — sajátot vagy nyilvánosat.",
  "reports.agroMeteorology": "Agrometeorológia",
  "reports.analysis": "Elemzés",
  "reports.annualCumulativeRainfallComparison": "Az éves csapadékösszeg összehasonlítása",
  "reports.annualHeatingDurationComparison": "A fűtési idő éves összehasonlítása",
  "reports.annualHeatingEfficiency": "Éves termikus hatásfok",
  "reports.annualIndoorComparison": "Éves beltéri összevetés",
  "reports.annualIndoorReport": "Éves beltéri jelentés",
  "reports.annualOutdoorComparison": "Éves kültéri összevetés",
  "reports.annualOutdoorReport": "Éves kültéri jelentés",
  "reports.annualReport": "Éves jelentés",
  "reports.annualSolarReport": "Éves napelemes jelentés",
  "reports.annualWaterBalance": "Éves vízmérleg",
  "reports.annualWaterBalanceCarryOver": "",
  "reports.annualWaterBalanceDescription": "A vízháztartás (egyszerűsített változat, csak eső és evapotranszspiráció használatos) lehetővé teszi a vízkészlet kezelését",
  "reports.avgHumidity": "Átlagos páratartalom",
  "reports.avgMaxTemperature": "Középhőmérsékleti T°max",
  "reports.avgMinTemperature": "Középhőmérsékleti T°min",
  "reports.avgPressure": "Légnyomás átlag",
  "reports.avgTemperature": "Középhőmérséklet",
  "reports.comfortable": "Komfortos (45% {lessThan} Páratartalom ≤ 60%)",
  "reports.cumulativeRainfall": "Csapadékösszeg",
  "reports.cumulativeRainfallDescription": "Kövesse a kiválasztott időszak alatt felhalmozódó teljes csapadékmennyiséget.",
  "reports.dailyMaxRainfall": "Napi csapadék maximum",
  "reports.dataExport": "Adatok exportálása",
  "reports.dataExportXlsxFormatDescription": "Az állomás összes adatának mentése Excel formátumba (* .xlsx). Miután a gombra kattintasz, néhány perc múlva kapni fogsz egy emailt a feldolgozott adatokkal.",
  "reports.daysWithFrost": "Fagyos napok",
  "reports.daysWithoutThaw": "Napok fagypont alatti maximummal",
  "reports.daysWithStrongFrost": "Erősen fagyos napok",
  "reports.emailSent": "E-mail címedre elküldtük az adatokat",
  "reports.grasslandTemperatureSum": "A gyephőmérséklet összege",
  "reports.grasslandTemperatureSumDescription": "A növényzet fenntartható helyreállítása, ha az összeg eléri a {threshold}",
  "reports.growingDegreeDays": "Növekedési foknapok",
  "reports.highPressure": "Magas légnyomás (> 1013 mbar)",
  "reports.indoorReport": "Beltéri jelentés",
  "reports.keyFacts": "Statisztika",
  "reports.longestRunOfRainyDays": "Az egymást követő esős napok száma",
  "reports.longestRunWithoutRun": "Az egymást követő napok száma eső nélkül",
  "reports.lowPressure": "Alacsony légnyomás ({lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maximum páratartalom",
  "reports.maxPressure": "Maximum légnyomás",
  "reports.maxPressureMagnitude24h": "Maximum eltérés (/24H)",
  "reports.maxTemperature": "Hőmérsékleti maximum",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximum eltérés (/24H)",
  "reports.minHumidity": "Minimum páratartalom",
  "reports.minPressure": "Minimum légnyomás",
  "reports.minPressureMagnitude24h": "Minimum eltérés (/24H)",
  "reports.minTemperature": "Hőmérsékleti minimum",
  "reports.minTempMagnitude24h": "Minimum eltérés (/24H)",
  "reports.monthlyHeatingEfficiency": "Havi termikus hatásfok",
  "reports.monthlyIndoorReport": "Havi beltéri jelentés",
  "reports.monthlyOutdoorReport": "Havi kültéri jelentés",
  "reports.monthlyReport": "Havi jelentés",
  "reports.monthlySolarReport": "Havi napelemes jelentés",
  "reports.monthlyWindReport": "Havi széljelentés",
  "reports.numberOfDays": "Napok száma",
  "reports.outdoorReport": "Kültéri jelentés",
  "reports.rainfall": "Csapadék",
  "reports.rainyDays": "Csapadékos napok",
  "reports.relativelyWet": "Viszonylag magas (60% {lessThan} Páratartalom ≤ 80%)",
  "reports.sendEmail": "E-mail küldése",
  "reports.tooDry": "Nagyon alacsony (Páratartalom ≤ 45%)",
  "reports.tooWet": "Nagyon magas (Páratartalom {greaterThan} 80%)",
  "reports.tropicalNights": "Trópusi éjszakák",
  "reports.waterBalance": "Víz egyensúly",
  "reports.yearToDateTemperature": "Éves hőmérséklet",
  "reports.yearToDateTemperatureComparison": "Évek közötti hőmérséklet-összehasonlítás",
  "sensors.aqiByChannel": "AQI csatornánként",
  "sensors.bgtSensors": "Fekete gömb & WBGT",
  "sensors.cameraFeed": "",
  "sensors.compareAqi": "AQI összehasonlítása",
  "sensors.compareHumidity": "Páratartalom összehasonlítása",
  "sensors.compareMoisture": "Talajnedvesség összehasonlítása",
  "sensors.comparePm25": "PM2.5 összehasonlítása",
  "sensors.compareTemperatures": "Hőmérsékletek összehasonlítása",
  "sensors.depthByChannel": "Mélység csatornánként",
  "sensors.heatStressExtreme": "Extrém hőstressz",
  "sensors.heatStressModerate": "Mérsékelt hőstressz",
  "sensors.heatStressNone": "Nincs hőstressz",
  "sensors.heatStressStrong": "Erős hőstressz",
  "sensors.heatStressVeryStrong": "Nagyon erős hőstressz",
  "sensors.humidityByChannel": "Páratartalom csatornánként",
  "sensors.indoorAirQuality": "Beltéri levegőminőség",
  "sensors.indoorAirQualityPm": "PM2.5 és PM10 AQI",
  "sensors.indoorClimate": "Beltéri klíma",
  "sensors.indoorCo2Levels": "CO2-szintek",
  "sensors.indoorTemperatureAndHumidity": "Hőmérséklet és páratartalom",
  "sensors.last24Hours": "24 óra",
  "sensors.last30Days": "30 nap",
  "sensors.last7Days": "7 nap",
  "sensors.leafTemperatureByChannel": "Levélhőmérséklet csatornánként",
  "sensors.leafWetnessByChannel": "Levélnedvesség csatornánként",
  "sensors.lightningSensor": "Villám",
  "sensors.moistureByChannel": "Talajnedvesség csatornánként",
  "sensors.noDataAvailable": "Nem áll rendelkezésre adat",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 csatornánként",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Csatorna kiválasztása",
  "sensors.sensorDetailDescription": "Tekintse meg a szenzorcsatornák előzményadatait és trendjeit.",
  "sensors.sensorHistory": "Szenzor előzmények",
  "sensors.soilTemperatureByChannel": "Talajhőmérséklet csatornánként",
  "sensors.strikesToday": "Becsapódások ma",
  "sensors.temperatureByChannel": "Hőmérséklet csatornánként",
  "settings.about": "Névjegy",
  "settings.aboutDescription": "Licencszerződés, adatvédelmi irányelvek",
  "settings.account": "Fiók",
  "settings.accountDescription": "Profil, jelszóváltoztatás",
  "settings.accountIntro": "Az alábbi fiókhoz tartozó adatok:",
  "settings.accountSection": "Fiók",
  "settings.appearance": "Megjelenés",
  "settings.appearanceDescription": "Téma és megjelenítési beállítások",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arab",
  "settings.availableServices": "Elérhető",
  "settings.bulgarian": "Bolgár",
  "settings.cannotDisconnectLastAccount": "Nem lehet leválasztani az egyetlen bejelentkezési módszert. Kérjük, először adjon hozzá egy másik bejelentkezési módszert.",
  "settings.changeEmail": "E-mail módosítása",
  "settings.changePassword": "Jelszó módosítása",
  "settings.chartGestures": "Gesztusok a diagramokon",
  "settings.chartGesturesDescription": "A diagramok ellopja az időtartamot, a diagramok megcsípése megváltoztatja az időskálát",
  "settings.connect": "Csatlakoztatás",
  "settings.connected": "Csatlakoztatva",
  "settings.connectedAccounts": "Csatlakoztatott fiókok",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Csatlakoztatva",
  "settings.connectedSince": "Csatlakoztatva {date} óta",
  "settings.connectionSuccess": "{provider} fiók sikeresen csatlakoztatva",
  "settings.contactUs": "Kapcsolat",
  "settings.contactUsDescription": "Segítség vagy visszajelzés küldése",
  "settings.croatian": "horvát",
  "settings.currentPassword": "Jelenlegi jelszó",
  "settings.czech": "cseh",
  "settings.danish": "dán",
  "settings.dark": "Sötét téma",
  "settings.dataDisplay": "Adatmegjelenítés",
  "settings.dateAndTime": "Dátum és óra",
  "settings.disconnect": "Leválasztás",
  "settings.disconnectConfirmation": "Biztosan le szeretné választani {provider} fiókját?",
  "settings.disconnectionSuccess": "{provider} fiók sikeresen leválasztva",
  "settings.donateButton": "Adományozás",
  "settings.donateDescription": "A SmartMixint egy kis csapat fejleszti. Ha hasznosnak találja, egyszeri, tetszőleges összegű adománnyal támogathatja a fejlesztését. Ez egy ajándék — nem módosítja a csomagját, és nem old fel semmilyen funkciót.",
  "settings.donateSuccessBody": "Az adománya segít, hogy a SmartMixin működjön és folyamatosan fejlődjön. Nagyon hálásak vagyunk érte.",
  "settings.donateSuccessTitle": "Köszönjük a támogatását!",
  "settings.donateTitle": "Támogassa a SmartMixint",
  "settings.dutch": "holland",
  "settings.emailChange": "E-mail cím módosítása",
  "settings.emailChangeConfirmation": "E-mail módosítás megerősítése",
  "settings.emailChangeFailure": "Az e-mail módosítási link érvénytelen vagy lejárt.",
  "settings.emailChangeSuccess": "Az e-mail címe sikeresen megváltozott erre: {newEmail}.",
  "settings.emailChangeVerificationSent": "Egy megerősítő e-mailt küldtünk az új e-mail címére. Kérjük, ellenőrizze a bejövő leveleket, és kattintson a linkre a módosítás megerősítéséhez.",
  "settings.english": "angol",
  "settings.forecastModelOrderEmpty": "Nincs mentett sorrend — alapértelmezés szerint a GFS-t használjuk.",
  "settings.forecastModelOrderFreeHint": "A prémium modellekhez SmartMixin Premium-előfizetés szükséges.",
  "settings.forecastModelOrderHelp": "A listád első olyan modelljét választjuk, amely az adott állomást lefedi.",
  "settings.forecastModelOrderReset": "Visszaállítás",
  "settings.forecastModelOrderTitle": "Alapértelmezett előrejelzési modell",
  "settings.forecastModels": "Előrejelzési modellek",
  "settings.forecastModelsDescription": "Átrendezés preferencia szerint",
  "settings.french": "francia",
  "settings.german": "német",
  "settings.gestures": "Gesztusok",
  "settings.greek": "görög",
  "settings.helpCenter": "Súgóközpont",
  "settings.helpCenterDescription": "GYIK és útmutatók",
  "settings.hungarian": "magyar",
  "settings.integrationsSection": "Integrációk",
  "settings.italian": "olasz",
  "settings.japanese": "japán",
  "settings.korean": "koreai",
  "settings.language": "Nyelv",
  "settings.languageDescription": "Preferált nyelv",
  "settings.light": "Világos téma",
  "settings.newEmailAddress": "Új e-mail cím",
  "settings.newPassword": "Új jelszó",
  "settings.newPasswordAgain": "Új jelszó megerősítése",
  "settings.norwegian": "Norvég",
  "settings.notConnected": "Nincs csatlakoztatva",
  "settings.notificationsSection": "Értesítések",
  "settings.oldPassword": "Régi jelszó",
  "settings.ongoingNotificationEnabled": "Állandó értesítés engedélyezése",
  "settings.ongoingNotificationMetrics": "Megjelenített mérőszámok",
  "settings.ongoingNotificationMetricsHint": "Húzza a kiválasztott mérőszámok átrendezéséhez",
  "settings.ongoingNotificationPermissionRequired": "Értesítési engedély szükséges",
  "settings.ongoingNotificationStation": "Meteorológiai állomás",
  "settings.passwordChange": "Jelszó módosítása",
  "settings.polish": "Lengyel",
  "settings.portuguese": "portugál",
  "settings.preferencesSection": "Beállítások",
  "settings.premium": "Premium",
  "settings.premiumActive": "Aktív",
  "settings.premiumAnnualThenPrice": "Ezt követően 9,99 €/év",
  "settings.premiumAnnualTrialInfo": "Kezdje egy {days} napos ingyenes próbaidőszakkal",
  "settings.premiumCurrentPlan": "Current Plan",
  "settings.premiumDescription": "Prémium funkciók feloldása",
  "settings.premiumDownloadApp": "Download the app to subscribe:",
  "settings.premiumExpiresOn": "Renews on {date}",
  "settings.premiumFreePlan": "Free",
  "settings.premiumInactive": "Nincs előfizetés",
  "settings.premiumManageWebSubscription": "Kezelje előfizetését, frissítse a fizetési módot vagy mondja le.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Éves — 9,99 €/év",
  "settings.premiumSubscribedOn": "Subscribed on {platform}",
  "settings.premiumSubscribeMonthly": "Havi — 1,99 €/hónap",
  "settings.premiumSubscribeOnWeb": "Fizessen elő most az összes prémium funkció feloldásához.",
  "settings.premiumSubscriptionSuccess": "Az előfizetése aktiválva lett! Élvezze az összes prémium funkciót.",
  "settings.premiumSubscriptionSuccessTitle": "Üdvözöljük a Premiumban!",
  "settings.premiumWebappNotice": "Subscriptions can only be purchased through the SmartMixin mobile app on iOS or Android.",
  "settings.privacyPolicy": "Adatvédelmi irányelvek",
  "settings.profile": "Profil",
  "settings.russian": "orosz",
  "settings.serbian": "szerb",
  "settings.settings": "Beállítások",
  "settings.slovak": "szlovák",
  "settings.smallDecimals": "Kis tizedesjegyek",
  "settings.smallDecimalsDescription": "Tizedesjegyek kisebb méretben történő megjelenítése",
  "settings.socialConnectionsIntro": "Csatlakoztassa közösségi fiókjait a gyors bejelentkezéshez. Bármikor csatlakoztathatja vagy leválaszthatja a fiókokat.",
  "settings.spanish": "Spanyol",
  "settings.statusBarWidget": "Állapotsor widget",
  "settings.statusBarWidgetDescription": "Mindig látható időjárási adatok",
  "settings.subscriptionSection": "Előfizetés",
  "settings.supportSection": "Támogatás",
  "settings.swedish": "Svéd",
  "settings.systemTheme": "Rendszer szerinti",
  "settings.termsOfService": "Szolgáltatási feltételek",
  "settings.turkish": "török",
  "settings.ukrainian": "ukrán",
  "settings.units": "Mértékegységek",
  "settings.unitsDescription": "Az alkalmazásban használatos mértékegységek",
  "settings.update": "Frissítés",
  "settings.updateYourProfile": "Adatok frissítése",
  "settings.weatherServices": "Időjárási szolgáltatások",
  "settings.weatherServicesConnected": "{count, plural, =0 {Nincs csatlakoztatott szolgáltatás} one {# csatlakoztatott szolgáltatás} other {# csatlakoztatott szolgáltatás}}",
  "settings.weatherServicesDescription": "Csatlakoztassa a Netatmo, Davis, Weatherflow és más eszközöket",
  "settings.windDirectionConvention": "Szélirány nyíl",
  "settings.windDirectionConventionDescription": "Válassza ki a szélirány nyilak megjelenítési módját",
  "settings.windDirectionMeteorological": "Eredet iránya",
  "settings.windDirectionMeteorologicalDescription": "A nyíl azt mutatja, honnan fúj a szél (meteorological konvenció)",
  "settings.windDirectionOceanographic": "Áramlási irány",
  "settings.windDirectionOceanographicDescription": "A nyíl azt mutatja, merre fúj a szél (oceanographic konvenció)",
  "units.absolutePressure": "Abszolút nyomás",
  "units.airDensity": "Légsűrűség",
  "units.airGap": "Légrés",
  "units.apparentTemperature": "Látszólagos hőmérséklet",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Átlag",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Fekete gömb hőm.",
  "units.boilerOn": "Kazán aktivitás",
  "units.co2": "CO2",
  "units.coolingDegreeDays": "Lehűlési fokos napok",
  "units.dailyHeatingDuration": "Napi fűtési idő",
  "units.dailyPrecipitation": "Napi csapadék",
  "units.dailyRain": "Napi csapadék",
  "units.degreeDay": "Fokozat-nap",
  "units.degreeDayShort": "DJU",
  "units.depth": "Mélység",
  "units.depthSensors": "Mélységérzékelők",
  "units.dewPoint": "Harmatpont",
  "units.distance": "Távolság",
  "units.downTrend": "Csökkenő trend",
  "units.E": "E",
  "units.E_long": "Keleti",
  "units.ENE": "ENE",
  "units.ENE_long": "kelet-északkelet",
  "units.ESE": "ESE",
  "units.ESE_long": "kelet-délkelet",
  "units.ET": "Evapotranszspiráció",
  "units.ETshort": "ÉS",
  "units.feelLike": "Hőérzet",
  "units.feelsLike": "Hőérzet",
  "units.footMile": "láb, mérföld",
  "units.frostPoint": "fagypont",
  "units.gust": "Széllökés",
  "units.heatIndex": "Hőindex",
  "units.heatingDegreeDays": "Fűtési fokos napok",
  "units.heatingPower": "Fűtőteljesítmény",
  "units.humidex": "Humidex",
  "units.humidity": "Páratartalom",
  "units.inch": "Inch",
  "units.inchOfMercury": "Higanyhüvelyk",
  "units.kilometerPerHour": "Kilométer per óra",
  "units.knot": "Csomó",
  "units.last12Hours": "",
  "units.last24Hours": "",
  "units.last3Hours": "",
  "units.last6Hours": "",
  "units.lastHour": "Előző órában",
  "units.lastLightningImpact": "Utolsó villámcsapás",
  "units.lastMeasure": "Utolsó intézkedés",
  "units.leafSensors": "Páratartalom érzékelők",
  "units.leafWetness": "A levél nedvessége",
  "units.lightningDistance": "Távolság",
  "units.lightningStrikeCount": "A villámcsapások száma",
  "units.lightningStrikeDistance": "Villámcsapás távolsága",
  "units.max": "Max.",
  "units.max_gust": "Max. széllökés",
  "units.max_wind": "Max. szél",
  "units.meterKilometer": "méter, kilométer",
  "units.meterPerSecond": "Méter per szekundum",
  "units.milePerHour": "Mérföld per óra",
  "units.millibar": "Millibar",
  "units.millimeter": "Milliméter",
  "units.millimeterOfMercury": "Higanymilliméter",
  "units.min": "Min.",
  "units.N": "N",
  "units.N_long": "északi",
  "units.NE": "NE",
  "units.NE_long": "északkeleti",
  "units.NNE": "NNE",
  "units.NNE_long": "észak-északkelet",
  "units.NNW": "NNW",
  "units.NNW_long": "észak-északnyugat",
  "units.noise": "Zaj",
  "units.normalizedHeatingCoefficient": "Normalizált fűtési együttható",
  "units.NW": "NW",
  "units.NW_long": "északnyugat",
  "units.O3": "Ózon",
  "units.PM_1": "PM 1",
  "units.PM_10": "PM 10",
  "units.PM_2P5": "PM 2.5",
  "units.precipitation": "csapadék",
  "units.pressure": "Légnyomás",
  "units.rain": "Csapadék",
  "units.rainRate": "Eső intenzitása",
  "units.referenceTemperature": "Referencia hőmérséklet",
  "units.relativePressure": "Relatív nyomás",
  "units.S": "S",
  "units.S_long": "déli",
  "units.SE": "SE",
  "units.SE_long": "Délkelet",
  "units.setPoint": "Célérték",
  "units.snow": "Hó",
  "units.snowfall": "Havazás",
  "units.soilMoisture": "Talajnedvesség",
  "units.soilSensors": "Padlóérzékelők",
  "units.solarEnergy": "Napenergia",
  "units.solarRadiation": "Napsugárzás",
  "units.speed": "Sebesség",
  "units.SSE": "SSE",
  "units.SSE_long": "dél-délkelet",
  "units.SSW": "SSW",
  "units.SSW_long": "dél-délnyugat",
  "units.stableTrend": "Stabil trend",
  "units.sum": "Összeg",
  "units.SW": "SW",
  "units.SW_long": "Délnyugat",
  "units.temperature": "Hőmérséklet",
  "units.temperatureAndHumiditySensors": "Hőmérséklet/nedvesség érzékelők",
  "units.temperatureSensors": "Hőmérséklet/nedvesség érzékelők",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Ma",
  "units.upTrend": "Emelkedés",
  "units.uv": "UV",
  "units.visibility": "Láthatóság",
  "units.W": "W",
  "units.W_long": "nyugat",
  "units.wetBulbGlobeTemperature": "Nedves gömb hőm.",
  "units.wetBulbTemperature": "Nedves hőmérséklet",
  "units.wind": "Szél",
  "units.windChill": "Szélhűtés",
  "units.windDirection": "Szélirány",
  "units.windRun": "a szél menete",
  "units.windRunDescription": "A szél útja a szél által egy bizonyos időtartam alatt megtett teljes távolság",
  "units.WNW": "WNW",
  "units.WNW_long": "nyugat-északnyugat",
  "units.WSW": "WSW",
  "units.WSW_long": "nyugat-délnyugat"
}
